<template>
  <div :class="[$style.root, { [$style.wide]: isWideVariant }]">
    <span :class="$style.innerMask" aria-hidden="true" />
    <img src="/figma/tire-wheel-base.svg" :class="$style.image" alt="" />
    <svg
      v-if="displayLabel"
      :class="$style.labelLayer"
      viewBox="0 0 406 406"
      aria-hidden="true"
    >
      <defs>
        <path :id="pathId" :d="labelPath" />
      </defs>
      <text
        :class="[
          $style.labelText,
          { [$style.placeholder]: isPlaceholder, [$style.labelTextWide]: isWideVariant },
        ]"
      >
        <textPath :href="`#${pathId}`" startOffset="50%" text-anchor="middle">
          {{ displayLabel }}
        </textPath>
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: "TireSizeWheel",
  props: {
    label: {
      type: String,
      default: "",
    },
    placeholderLabel: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "single",
    },
  },
  computed: {
    pathId() {
      return `tire-wheel-label-${this.$?.uid ?? this._uid ?? "single"}`;
    },
    isWideVariant() {
      return this.variant === "wide";
    },
    displayLabel() {
      return this.label || this.placeholderLabel;
    },
    isPlaceholder() {
      return !this.label && Boolean(this.placeholderLabel);
    },
    labelPath() {
      return this.isWideVariant
        ? "M58 226A148 112 0 0 1 348 226"
        : "M46 176A340 340 0 0 1 360 176";
    },
  },
};
</script>

<style lang="scss" module>
.root {
  position: relative;
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
}

.innerMask {
  position: absolute;
  left: 50%;
  bottom: 9.5%;
  width: 66%;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #fff;
  transform: translateX(-50%);
  z-index: 0;
}

.image {
  width: 100%;
  display: block;
  position: relative;
  z-index: 1;
}

.labelLayer {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: visible;
  z-index: 2;
}

.labelText {
  fill: $t-white;
  font-family: Inter, sans-serif;
  font-size: 58px;
  font-weight: 600;
  letter-spacing: 0;
}

.labelTextWide {
  font-size: 58px;
}

.placeholder {
  fill: rgba(255, 255, 255, 0.16);
}
</style>
